import React, { useState } from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const LABEL_SEARCH = 'Search';

type ImperativeResetRef = {
  reset: () => void;
}

type Props = {
  input?: React.MutableRefObject<ImperativeResetRef | null>;
  inputProps?: Omit<
    React.ComponentPropsWithRef<typeof Input>,
    'value' | 'onChange' | 'onKeyDown' | 'prefix' | 'placeholder'
  >;
  onSearch: (value: string) => void;
  minCharacters?: number;
}

const SearchInput = ({
  input,
  inputProps = {},
  onSearch,
  minCharacters = 3,
}: Props) => {
  const [searchValue, setSearchValue] = useState<string>('');

  const reset = () => {
    setSearchValue('');
    onSearch('');
  };

  if (input) {
    input.current = input.current || { reset };
    input.current.reset = reset;
  }

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    setSearchValue(value);

    const shouldSearch = value.length >= minCharacters || value.length === 0;
    if (shouldSearch) {
      onSearch(value);
      return;
    }

    onSearch('');
  };

  const onKeyDown = ({ key }: React.KeyboardEvent<HTMLInputElement>) => {
    const isEsc = key === 'Escape';
    
    if (!isEsc) {
      return;
    }

    reset();
  };

  const style: React.CSSProperties = { width: 280 };

  return (
    <Input
      allowClear
      value={searchValue}
      style={style}
      prefix={<SearchOutlined />}
      onChange={handleSearch}
      onKeyDown={onKeyDown}
      placeholder={LABEL_SEARCH}
      {...inputProps}
    />
  );
};

export default SearchInput;

